export default "__VITE_ASSET__BAY39nO7__"